export * from './shelter-store';

export function encodeReuniDesc(desc: string, dob: string, phone: string, age: string, source?: string): string {
  if (!dob && !phone && !age && !source) return desc || '';
  const meta = JSON.stringify({ dob: dob || '', phone: phone || '', age: age || '', source: source || '' });
  return `|||META|||${meta}|||ENDMETA|||${desc || ''}`;
}

export function decodeReuniDesc(raw: string): { description: string; dob: string; phone: string; age: string; source: string } {
  if (!raw) return { description: '', dob: '', phone: '', age: '', source: '' };
  const metaRe = /\|\|\|META\|\|\|(.*?)\|\|\|ENDMETA\|\|\|([\s\S]*)/;
  const m = raw.match(metaRe);
  if (!m) return { description: raw, dob: '', phone: '', age: '', source: '' };
  try {
    const meta = JSON.parse(m[1]);
    return { description: m[2], dob: meta.dob || '', phone: meta.phone || '', age: meta.age || '', source: meta.source || '' };
  } catch {
    return { description: raw, dob: '', phone: '', age: '', source: '' };
  }
}
